import { memo } from 'react';
import { useSelector } from 'react-redux';

const Footer = () => {
  const userInfo = useSelector((state) => state.authReducer.data);
  return (
    <footer className="sticky-footer bg-white">
      <div className="container my-auto">
        <div className="copyright">
          <span>Copyright &copy; Prescripto</span>
          {userInfo?.userType === 'doctor' && (
            <span>All Rights Reserved by {userInfo.name}</span>
          )}
          <span className="float-right">
            Help Line:
            <i className="fas fa-phone-alt pr-1 pl-1"></i>
            <span>01841841101</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
